module.exports = __webpack_public_path__ + "img/status-normal.5bab95b3.svg";